<script setup lang="ts">
import { computed } from "vue";
import { useRoute } from "vue-router";

import { navigationActions } from "@/action/navigationActions";
import ActionMenuButton from "@/components/menu/ActionMenu/ActionMenuButton.vue";
import { isFeatureEnabled } from "@/utils/env/feature";

const route = useRoute();

const isVisible = computed(() => isFeatureEnabled(route, "explorer"));
</script>

<template>
  <ActionMenuButton v-if="isVisible" :action="navigationActions.showMap" highlight="map" />
</template>
